<template>
  <div>
    <div class="contents">
      <ValidationObserver ref="observer" v-slot="{ passes }">
        <b-form @submit.prevent="passes(onSubmit)">
          <div class="row g-2">
            <div class="col-lg-4">
              <select class="form-select-lg" v-model="form.type">
                <option value="1">{{ $t("filter.support.notice") }}</option>
                <option value="2">{{ $t("filter.support.patch") }}</option>
              </select>
            </div>
            <div class="col-lg-8">
              <input
                type="text"
                v-model="form.title"
                required
                :placeholder="$t('text.common.enter_title')"
              />
            </div>

            <div class="col-lg-12 input-group">
              <input
                type="text"
                class="form-control text-truncate"
                :value="filename_"
                :placeholder="$t('text.common.no_file_chosen')"
              />
              <button
                type="button"
                class="btn btn-primary btn-lg icon-attachment"
                @click="$refs.file.click()"
              >
                {{ $t("button.common.choose_file") }}
                <input
                  type="file"
                  ref="file"
                  @change="fileSelect()"
                  class="d-none"
                />
              </button>
            </div>
          </div>

          <article class="article-attach" v-if="form.originname">
            <a :href="form.filename | get_img">
              <i class="material-icons-outlined">file_download</i>
              <span>{{ form.originname }}</span>
            </a>
          </article>

          <div class="d-flex flex-column flex-sm-row my-2">
            <div class="my-1 pe-3">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="form.status"
                  true-value="1"
                  false-value="0"
                  id="flexCheck1"
                />
                <label class="form-check-label" for="flexCheck1">
                  {{ $t("text.support.check_upload") }}
                </label>
              </div>
            </div>
            <div class="my-1 pe-3">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="form.topstatus"
                  true-value="1"
                  false-value="0"
                  id="flexCheck2"
                />
                <label class="form-check-label" for="flexCheck2">
                  {{ $t("text.support.check_top_display") }}
                </label>
              </div>
            </div>
          </div>

          <div class="box">
            <p class="content">
              <ValidationProvider
                name="Contents"
                rules="required"
                immediate
                v-slot="{ errors }"
              >
                <ckeditor
                  tag-name="textarea"
                  ref="cktext"
                  v-model="form.contents"
                  :config="editorConfig"
                />
                <p class="text-subscript mt-2 text-orange" v-if="errors[0]">
                  <i class="material-icons align-text-top"
                    >report_gmailerrorred</i
                  >
                  {{ $t("text.support.content_required") }}
                </p>
              </ValidationProvider>
            </p>
          </div>

          <div class="btn-bottom-wrapper">
            <b-button
              size="xl"
              variant="outline-primary"
              :aria-label="$t('button.common.list')"
              @click="$router.push({ name: 'OwnerNoticeList' })"
              >{{ $t("button.common.list") }}</b-button
            >
            <b-button
              size="xl"
              variant="primary"
              :aria-label="$t('button.common.save')"
              type="submit"
              >{{ $t("button.common.save") }}</b-button
            >
          </div>
        </b-form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/support";
import options from "@/config/options";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import InputWithValidation from "@/components/common/validations/inputbox";
import SelectBoxWithValidation from "@/components/common/validations/selectbox";
import router from "@/router";

export default {
  name: "OwnerNoticeWrite",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      form: {
        type: "1",
        title: "",
        contents: "",
        filename: "",
        status: "0",
        topstatus: "0",
      },
      filename_: "",
      typeOptions: [
        { value: "1", text: "Notice" },
        { value: "2", text: "News" },
      ],
      statusOptions: options.statusOptions,
      noticeno: this.$route.params.noticeno || "",
      editorConfig: {
        versionCheck: false,
        // The configuration of the editor.
        height: "200px",
        language: "en",
        toolbar: [
          ["Source"],
          ["Link"],
          ["Styles", "Format", "Font", "FontSize"],
          ["Bold", "Italic"],
          ["Undo", "Redo"],
          ["About"],
        ],
      },
    };
  },
  created() {
    this.getView();
  },
  methods: {
    onSubmit() {
      if (this.form.title == "") {
        alert(this.$i18n.t("alert.common.title_required"));
        return false;
      }

      let self = this;
      let formData = new FormData();
      formData.append("noticeno", this.noticeno);
      formData.append("type", this.form.type);
      formData.append("title", this.form.title);
      formData.append("filename", this.form.filename);
      formData.append("contents", this.form.contents);
      formData.append("status", this.form.status);
      formData.append("topstatus", this.form.topstatus);
      formData.entries();
      if (this.noticeno) {
        ax.getOwnerNoticeModify(
          formData,
          this.noticeno,
          function (flag, data, code) {
            if (flag) {
              alert(data.message);
              self.$router.push({ name: "OwnerNoticeList" });
            } else {
              alert(data);
            }
          }
        );
      } else {
        ax.getOwnerNoticeWrite(formData, function (flag, data) {
          console.log(flag, data);
          if (flag) {
            alert(data.message);
            self.$router.push({ name: "OwnerNoticeList" });
          } else {
            alert(data);
          }
        });
      }
    },
    getView() {
      if (this.noticeno) {
        ax.getOwnerNoticeview(this.noticeno, {}, (flag, data) => {
          if (flag) {
            this.form = data.noticeview;
          } else {
            alert(data);
          }
        });
      }
    },
    typeChange(v) {
      this.form.type = v;
    },
    statusChange1(v) {
      this.form.status = v;
    },
    statusChange2(v) {
      this.form.topstatus = v;
    },
    fileSelect() {
      this.filename_ = this.$refs.file.files[0].name;
      this.form.filename = this.$refs.file.files[0];
    },
  },
};
</script>
